import { PropsWithChildren } from 'react'
import styles from './ModalCard.module.css'
import { ModalTypes } from '@/interfaces/api/generic/api_modals_types'
import Icon from '../../Icon/Icon'
import Icon_Cross from '@/assets/img/Icon_Cross.svg'

interface ModalCardProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: ModalTypes,
  onClose: () => void
}

export default function ModalCard ({ type=ModalTypes.NATIVE, className, children, onClose, ...rest }: PropsWithChildren<ModalCardProps>) {

  return (
    <div
      className={`${styles.modalCard} ${type ?? ''} ${className ?? ''}`} data-testid="ModalCard"
      {...rest}
    >
      <Icon className={styles.cross} icon={Icon_Cross} onClick={onClose} data-testid="ModalCard_Icon"/>
      {children}
    </div>
  )
}